import React, { FC } from "react";
import { Control } from "react-hook-form";

import SelectBase, { SelectProps } from "@/components/ui/Form/Select/SelectBase";
import SelectControlled from "@/components/ui/Form/Select/SelectControlled";

import "./select.css";

export interface DynamicSelectProps extends SelectProps {
  control?: Control<any>;
}
const Select: FC<DynamicSelectProps> = (args) => {
  return <>{args?.control ? <SelectControlled control={args.control} {...args} /> : <SelectBase {...args} />}</>;
};
export default Select;
